import styled from '@emotion/styled'

export const DashboardWrapper = styled('div', { shouldForwardProp: (prop) => prop !== 'showFilterSubHeader' })<{
    showFilterSubHeader?: boolean
}>`
    position: absolute;
    left: 0;
    width: 100%;
    /* Removing header's height and filters subheader (if any) to avoid the internal scroll */
    height: calc(100% - 55px - ${({ showFilterSubHeader }) => (showFilterSubHeader ? 25 : 0)}px);
    overflow: hidden;

    & iframe {
        border: none !important;
        overflow: hidden;
    }
`

export const PowerBIiFrame = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
`
